import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MultitrackAudioIcon(props: IconProps) {
    return <Icon {...props} iconKey={"multitrack_audio"}/>
}
